import React from 'react';
import {
  Box, Typography, Paper, List, ListItem, ListItemIcon, ListItemText,
  Avatar, Divider, Stack, Link
} from '@mui/material';
import { Link as RouterLink } from "react-router-dom";
import CircleIcon from '@mui/icons-material/Circle';
import { isEmpty, urlImg } from '../../common/helpers';

const BulletItem = ({ text, color = '#A5B4FC' }) => (
  <ListItem sx={{ alignItems: 'flex-start', py: 0.5, px: 0 }}>
    <ListItemIcon sx={{ minWidth: 28, mt: 0.8 }}>
      <CircleIcon sx={{ fontSize: 16, color }} />
    </ListItemIcon>
    <ListItemText
      primary={text}
      primaryTypographyProps={{ variant: 'body2', color: '#737791', lineHeight: 1.6 }}
    />
  </ListItem>
);

const ServiceContent = ({ service, profile, user }) => {
  const { descripcion, incluye, infoAdicional } = service;
  // Split includes and additional info by lines if they come as strings
  const includesList = typeof incluye === 'string' ? incluye.split('\n').filter(i => i.trim() !== '') : incluye || [];
  const additionalInfoList = typeof infoAdicional === 'string' ? infoAdicional.split('\n').filter(i => i.trim() !== '') : infoAdicional || [];

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" fontWeight="bold" color="#0E2465">
          Sobre el servicio
        </Typography>
        <Typography variant="body2" color="#737791">
          Conoce más detalles
        </Typography>
      </Box>

      <Paper elevation={0} sx={{ p: 4, borderRadius: '12px', border: '1px solid #F0F0F0', backgroundColor: '#FFF' }}>
        {/* Description Section */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="subtitle2" fontWeight="bold" color="#0E2465" gutterBottom>
            Descripción
          </Typography>
          <Typography variant="body2" color="#737791" sx={{ lineHeight: 1.6 }}>
            {descripcion || 'Mejora la presentación de tus postres y platillos con una consultoría remota de food styling personalizada.'}
          </Typography>
        </Box>

        {/* Qué incluye Section */}
        {includesList.length > 0 && (
          <Box sx={{ mb: 4 }}>
            <Divider sx={{ mb: 4 }} />
            <Typography variant="subtitle2" fontWeight="bold" color="#0E2465" gutterBottom>
              Qué incluye
            </Typography>
            <List sx={{ pt: 0 }}>
              {includesList.map((item, index) => <BulletItem key={index} text={item} />)}
            </List>
          </Box>
        )}

        <Divider sx={{ mb: 4 }} />

        {/* Quién lo imparte Section */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="subtitle2" fontWeight="bold" color="#0E2465" gutterBottom>
            Quién lo imparte
          </Typography>
          <Link
            component={RouterLink}
            to={`/perfil/${user?._id || profile?._id}`}
            underline="none"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              mb: 1.5,
              cursor: 'pointer',
              '&:hover': { opacity: 0.8 }
            }}
          >
            <Avatar
              src={!isEmpty(user?.avatar) && `${urlImg}/w_48,h_48,c_fill/users/${user._id}/${user.avatar}`}
              sx={{ width: 48, height: 48 }}
            />
            <Box>
              <Typography variant="subtitle2" fontWeight="bold" color="#0E2465">
                {user ? `${user.name} ${user.apellido}` : (profile?.nombre || 'Nombre no disponible')}
              </Typography>
              <Typography variant="caption" color="#737791">
                {profile?.perfil?.rol || 'Facilitador'} • ★ 4.9
              </Typography>
            </Box>
          </Link>
          <Typography variant="body2" color="#737791" sx={{ lineHeight: 1.6 }}>
            {profile?.perfil?.desc || `Hola, soy ${user?.name || profile?.nombre?.split(' ')[0] || 'tu facilitador'}. Estoy aquí para ayudarte a alcanzar tus objetivos con este servicio.`}
          </Typography>
        </Box>


        {/* Info adicional Section */}
        {additionalInfoList.length > 0 && (
          <>
            <Divider sx={{ mb: 4 }} />
            <Box>
              <Typography variant="subtitle2" fontWeight="bold" color="#0E2465" gutterBottom>
                Info adicional
              </Typography>
              <List sx={{ pt: 0 }}>
                {additionalInfoList.map((item, index) => <BulletItem key={index} text={item} color="#A7F3D0" />)}
              </List>
            </Box>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default ServiceContent;
